import { useCookieContext } from "../../context/CookieContext";
import styles from "./CookiePopupButton.module.scss"; // той самий, що для банера

const CookiePopupButton = () => {
  const { openBanner } = useCookieContext();

  return (
    <button
      onClick={openBanner}
      className={styles.popupButton}
      aria-label="Cookie-Einstellungen öffnen"
    >
      <img src="/images/cookie.svg" alt="" aria-hidden="true" />
    </button>
  );
};

export default CookiePopupButton;
